import { RecipeStatus } from "../models/recipe";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetRetailListParams {
  current: number;
  size?: number;
  param?: string;
  operateUser?: string;
  state?: RecipeStatus;
  timeHead?: string;
  timeTail?: string;
}

export function getRetailList(params: GetRetailListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/list`,
    method: "GET",
    params,
  };
}
